import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const BorderThickness = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 5.41667C2.5 4.72631 3.05964 4.16667 3.75 4.16667H16.25C16.9404 4.16667 17.5 4.72631 17.5 5.41667C17.5 6.10702 16.9404 6.66667 16.25 6.66667H3.75C3.05964 6.66667 2.5 6.10702 2.5 5.41667ZM2.5 10.8333C2.5 10.3731 2.8731 10 3.33333 10H16.6667C17.1269 10 17.5 10.3731 17.5 10.8333C17.5 11.2936 17.1269 11.6667 16.6667 11.6667H3.33333C2.8731 11.6667 2.5 11.2936 2.5 10.8333ZM2.91667 15C2.68655 15 2.5 15.1865 2.5 15.4167C2.5 15.6468 2.68655 15.8333 2.91667 15.8333H17.0833C17.3135 15.8333 17.5 15.6468 17.5 15.4167C17.5 15.1865 17.3135 15 17.0833 15H2.91667Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default BorderThickness
